import React, { useEffect, useMemo } from 'react';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import { Alert, Box, Button, Icon, Paper } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getCimsToken } from '../../redux/features/generalSlice';
import Loader3D from '../../components/Loader/Loader3D';

const cimsUrl = `${process.env.REACT_APP_CIMS_URL}cims`;

export default function CimsLanding({ isAdmin }) {
  const dispatch = useDispatch();
  const cimsToken = useSelector((state) => state.general.cimsToken.data);
  const cimsTokenLoading = useSelector((state) => state.general.cimsToken.loading);
  const profile = useMemo(() => {
    const profile = JSON.parse(localStorage.getItem('cred'))?.profile;

    return profile?.departmentId !== 26 ? profile?.role : '';
  }, []);

  const getCimsTokenForNav = () => {
    const params = {
      module: 'cims',
      role: isAdmin ? 'admin' : 'user',
      expiresIn: '1m',
    };
    dispatch(getCimsToken(params));
  };

  const gotoCims = () => {
    if (cimsToken && !cimsTokenLoading) {
      window.open(`${cimsUrl}?token=${cimsToken}${profile?.toLowerCase()?.includes('quality') ? '&pqd=true' : ''}`);
    }
  };

  useEffect(() => {
    getCimsTokenForNav();
  }, [isAdmin]);

  useEffect(() => {
    gotoCims();
  }, [cimsToken, cimsTokenLoading]);

  return (
    <GlobalWrapper title={isAdmin ? 'Admin CIMS' : 'Client Interactions'}>
      {cimsTokenLoading && <Loader3D />}
      {cimsToken && !cimsTokenLoading && (
        <Paper elevation={6} sx={{ p: 3 }}>
          <Button
            endIcon={<Icon icon="ix:goto" width="25" height="25" style={{ color: '#41e20f' }} />}
            sx={{ boxShadow: 'none', px: 2 }}
            variant="outlined"
            color="success"
            onClick={gotoCims}
          >
            Go To
          </Button>
        </Paper>
      )}
      {!cimsToken && !cimsTokenLoading && (
        <Paper elevation={6} sx={{ p: 1, textAlign: 'center' }}>
          <Box sx={{ textAlign: 'center', fontSize: 20 }}>
            <Alert severity="error">Something went wrong, please try again later.</Alert>
          </Box>
          <Button
            variant="outlined"
            color="error"
            onClick={getCimsTokenForNav}
            sx={{
              my: 2,
              px: 4,
              borderRadius: '30px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: 'none',
            }}
          >
            Retry
          </Button>
        </Paper>
      )}
    </GlobalWrapper>
  );
}
